module.exports = __webpack_public_path__ + "94ff81c982f307cfdcd0174e4d1b96fb.otf";